import React, { useEffect, useState } from "react";
import api from "../api/api";
import dayjs from "dayjs";
import ClearIcon from "@mui/icons-material/Clear";
import dollarImage from "../assets/Signin/Dollar.svg";
import { showToast } from "../reduxtoolkit/toastslice";
import { useDispatch } from "react-redux";
import { getPracticeId } from "../config/practice";

const ReportPaymentModal = ({ isOpen, data, onClose, updatedata }) => {

  const practiseid = getPracticeId();
  const loginUser = localStorage.getItem("user");

  const [copay, setCopay] = useState(0);
  const [selfPay, setSelfPay] = useState(0);
  const [paymentOnAccount, setPaymentOnAccount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
const dispatch=useDispatch()
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [ccnumber, setCcnumber] = useState("");

  useEffect(() => {
    if (data) {
      setCopay(data.copay || 0);
      setSelfPay(data.selfpay || 0);
      setPaymentOnAccount(data.paymentonaccount || 0);
      setTotalAmount(data.amount || 0);
      setCcnumber(data.ccnumber || "");
      
    }
  }, [data]);

 useEffect(() => {
  const fetchPaymentMethods = async () => {
    try {
      const res = await api.get(`/v1/${practiseid}/payments/payment-methods`);

      if (res.status === 200) {

        const methods = res.data;
        setPaymentMethods(methods);

        if (data?.payment_method) {
          const selected = methods.find(
            m => m.id === Number(data.payment_method)
          );

          if (selected) {
            setSelectedMethod(selected);
          }
        }

      }

    } catch (e) {
      console.log(e);
    }
  };

  fetchPaymentMethods();
}, [data]);
  useEffect(()=>{
console.log(data)
  },[data])

  // Auto calculate total
  useEffect(() => {
    const total =
      (parseFloat(copay) || 0) +
      (parseFloat(selfPay) || 0) +
      (parseFloat(paymentOnAccount) || 0);

    setTotalAmount(total);
  }, [copay, selfPay, paymentOnAccount]);
  

  const fetchPaymentMethods = async () => {
    try {
      const res = await api.get(`/v1/${practiseid}/payments/payment-methods`);

      if (res.status === 200) {
        setPaymentMethods(res.data);
      }

    } catch (e) {
      console.log(e);
    }
  };

  const handleSubmit = async () => {
  if (!selectedMethod) {
    dispatch(showToast({
      message: "Please select payment method",
      severity: "warning"
    }));
    return;
  }
if (selectedMethod?.method !== "CASH" && !ccnumber) {
  dispatch(showToast({
    message: "Please enter last 4 digits",
    severity: "warning"
  }));
  return;
}
    const payload = {
      payment_id: data.payment_id,
      patientid: data.patientid,
      appointmentid: data.appointmentid,
      patientname: data.patient_name,
      amount: totalAmount,
      paymentmethodid: selectedMethod.id,
      ccnumber: ccnumber,
      paymentstatus: data.payment_status,
      paymentlocation: data.payment_location,
      paymenttype: selectedMethod.type,
      copay: copay,
      paymentonaccount: paymentOnAccount,
      selfpay: selfPay,
      createdby: loginUser
    };

    try {
        console.log(payload)
        

      const response = await api.post(
        `/v1/${practiseid}/patient-payments/update`,
        payload
      );

      if (response.status === 200) {

        updatedata({
          ...data,
          copay,
          selfpay: selfPay,
          paymentonaccount: paymentOnAccount,
          amount: totalAmount
        });
     dispatch(showToast({
       message: response.message,
       severity: "success"
     }));
        
        onClose();
      }

    } catch (error) {
      console.log(error);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50">

      <div className="bg-white rounded-lg  text-start p-6 w-[420px]">

        {/* Header */}

        <div className="flex justify-between items-center border-b pb-2 mb-4">

          <h2 className="text-lg font-semibold">
            Update Payment
          </h2>

          <ClearIcon
            className="cursor-pointer"
            onClick={onClose}
          />

        </div>

        {/* Patient Info */}

<div className="rounded-[8.75px] border-2 border-[#E4E4E7] bg-[#FAFAFA] px-6 py-4 text-center">

  <div className="text-lg font-semibold">
    <span className="font-bold text-[20px] text-[#18181B]">
      {data?.patient_name}
    </span>{" "}
    {data?.patientid}
  </div>

  <div className="text-sm text-[#3F3F46] mt-1">
    {dayjs(data?.startdate).format("MMMM D YYYY")}
  </div>

  <div className="text-sm text-[#52525C] mt-1">
    {data?.insurancename}
  </div>

</div>

        {/* Payment Method */}

        <div className="mb-3">

          <label className="text-sm font-semibold">
            Payment Method
          </label>

        <select
  className="w-full border rounded-md p-2 mt-1"
  value={selectedMethod?.id || ""}
  onChange={(e) => {

    const method = paymentMethods.find(
      m => m.id === Number(e.target.value)
    );

    setSelectedMethod(method);
  }}
>
  <option value="">Select Payment Method</option>

  {paymentMethods.map(method => (
    <option key={method.id} value={method.id}>
      {method.method}
    </option>
  ))}
</select>

        </div>

        {/* Card / Check Number */}

        {selectedMethod && selectedMethod.method !== "CASH" && (

          <div className="mb-3">

            <label className="text-sm font-semibold">
              Enter 4-digit number
            </label>

            <input
              value={ccnumber}
              onChange={(e) => setCcnumber(e.target.value)}
              maxLength="4"
              className="w-full border rounded-md p-2 mt-1"
            />

          </div>

        )}

        {/* Copay */}

        <AmountField
          label="Co-pay"
          value={copay}
          setValue={setCopay}
        />

        {/* Self Pay */}

        <AmountField
          label="Self Pay"
          value={selfPay}
          setValue={setSelfPay}
        />

        {/* Payment on Account */}

        <AmountField
          label="Payment on Account"
          value={paymentOnAccount}
          setValue={setPaymentOnAccount}
        />

        {/* Total (Disabled) */}

        <div className="flex justify-between items-center mt-2">

          <label className="text-sm font-semibold">
            Total
          </label>

          <div className="flex items-center border rounded-md px-2 w-[60%]">

            <img src={dollarImage} alt="$" />

            <input
              type="number"
              value={totalAmount}
              disabled
              className="w-full outline-none px-2 py-1 bg-gray-100"
            />

          </div>

        </div>
            <div className="text-sm  mt-1 font-semibold text-[#71717A]">
                    Insurance:{data?.insurance}
                  </div>

        {/* Submit */}

        <button
          onClick={handleSubmit}
          className="w-full bg-black text-white py-2 rounded-md mt-6"
        >
          Update Payment
        </button>

      </div>

    </div>
  );
};


/* Reusable Amount Field */

const AmountField = ({ label, value, setValue }) => {

  return (

    <div className="flex justify-between items-center mt-2">

      <label className="text-sm font-semibold">
        {label}
      </label>

      <div className="flex items-center border rounded-md px-2 w-[60%]">

        <img src={dollarImage} alt="$" />

        <input
          type="number"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="w-full outline-none px-2 py-1"
          onWheel={(e) => e.target.blur()}
        />

      </div>

    </div>

  );

};

export default ReportPaymentModal;